import { render, staticRenderFns } from "./RightGlobalTable.vue?vue&type=template&id=5e26618a&"
import script from "./RightGlobalTable.vue?vue&type=script&lang=js&"
export * from "./RightGlobalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports